import React from 'react';

export function ArrowDropdownDown(props: React.SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="currentColor"
      height="5"
      viewBox="0 0 10 5"
      width="10"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M0 0L5 5L10 0H0Z" />
    </svg>
  );
}
